import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {UserService} from './user.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CustomerService {

  getAll(): Observable<Array<Customer>> {
    return this.http.get('/api/customers', {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().data)
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  findById(id: string): Observable<Customer> {
    return this.http.get('/api/customers/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  };

  verifyExists(id: string): Observable<boolean> {
    return this.http.get('/api/customers/check/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().id ? true : false)
      .catch((error: any) => {
        if (error.status === 404 && error.json().message === 'CUSTOMER_NOT_FOUND') {
          return Observable.of(false);
        }
        console.log(`Received error:${JSON.stringify(error)}`);
        return Observable.throw(error.json().message || 'Server error');
      });
  };

  save(s: Customer): Observable<Customer> {
    return this.http.post('/api/customers', s, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().message || 'Server error'));
  }

  remove(id: string): Observable<string> {
    return this.http.delete('/api/customers/' + id, {'headers': this.us.getAuthHeaders()})
      .map((res: Response) => res.json().id)
      .catch((error: any) => Observable.throw(error.message || 'Server error'));
  }

  constructor(private http: Http, private us: UserService) {
  }
}

export class Customer {
  constructor(public id: string, public name: string, public servers: Array<string>) {
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/customer.service.ts